/**
 * Created by PhpStorm.
 * User: shlomy
 * Date: 19/07/2023
 * Time: 13:03
 */
import { mediaCdnReplace } from '../../utils'
import { IDimension } from './types'

const blockquote_pattern = /<p>\[blockquote_h text='(.*)'\s\]<\/p>/g

export const cleanHtmlString = (str: string) =>
  mediaCdnReplace(str)
    ?.replace(
      blockquote_pattern,
      '<div class="blockquote"><blockquote>$1</blockquote></div>'
    ) // TODO: Remove blockquote workaround based on input from Reshet
    ?.replace(/role=\\"\\"/g, '')
    ?.replace(/&amp;/g, '&') //TODO: HACK: double encoding fix on qdata
export const getNodesFromHtmlText = (html: string) => {
  const div = document.createElement('div')

  div.innerHTML = cleanHtmlString(html)
  return (Array.from(div.childNodes) as HTMLElement[]).filter(
    t => t.nodeType !== Node.TEXT_NODE
  )
}

export const cleanOutEndingEmptyLines = (html: string) => {
  //clean out empty lines at the end of the article
  const childNodes = getNodesFromHtmlText(html).reverse()
  if (childNodes.length > 0) {
    while (
      childNodes[0] &&
      childNodes[0].nodeName === 'P' &&
      (childNodes[0].innerHTML === '' ||
        childNodes[0].innerHTML === ' ' ||
        childNodes[0].innerHTML === '&nbsp;')
    ) {
      childNodes.splice(0, 1)
    }
  }
  return childNodes.reverse()
}
export const getWidthAndHeightFromEmbedTag = (embedTag: string): IDimension => {
  const widthMatch = embedTag.match(/width="(\d+)"/)
  const heightMatch = embedTag.match(/height="(\d+)"/)

  const dimension: IDimension = {
    width: 640,
    height: 360,
  }

  if (widthMatch) {
    dimension.width = parseInt(widthMatch[1])
  }

  if (heightMatch) {
    dimension.height = parseInt(heightMatch[1])
  }

  return dimension
}
export const embedRegex =
  /\[embed(?:\s+width="\d+"\s+height="\d+")?](.*?)\[\/embed\]/g
